import { LazyLoadImage } from "react-lazy-load-image-component";
import { ComponentType } from "react";
import type { LazyLoadImageProps } from "react-lazy-load-image-component";

export const SafeLazyLoadImage = LazyLoadImage as ComponentType<LazyLoadImageProps>;
